"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelection = exports.SELECTION_MOD = void 0;
const react_1 = require("react");
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
var SELECTION_MOD;
(function (SELECTION_MOD) {
    SELECTION_MOD["single"] = "single";
    SELECTION_MOD["multi"] = "multi";
})(SELECTION_MOD = exports.SELECTION_MOD || (exports.SELECTION_MOD = {}));
function useSelection({ data, selectedIds, idAccessor = (item) => item.id, mode = SELECTION_MOD.single }) {
    const prevData = (0, react_1.useRef)(data);
    const prevSelectedIds = (0, react_1.useRef)(selectedIds);
    function computeSelected(indexes, ids) {
        const resultState = {
            dataList: [],
            indexList: [],
            idList: []
        };
        for (let i = 0; i < data.length; i++) {
            if (!indexes.length && !ids.length) {
                break;
            }
            const item = data[i];
            if (indexes.length) {
                indexes.forEach((index) => {
                    if (index === i) {
                        resultState.dataList.push(item);
                        resultState.indexList.push(index);
                        const id = idAccessor(item);
                        if (id || id === 0) {
                            resultState.idList.push(id);
                        }
                    }
                });
            }
            if (ids.length) {
                ids.forEach((id) => {
                    const itemId = idAccessor(item);
                    if ((itemId || itemId === 0) && itemId === id) {
                        resultState.dataList.push(item);
                        resultState.indexList.push(i);
                        resultState.idList.push(id);
                    }
                });
            }
        }
        return resultState;
    }
    const [selected, setSelected] = (0, react_1.useState)(computeSelected([], selectedIds || []));
    const setSelectedIdList = (result, callback) => {
        setSelected(result);
        if (callback) {
            callback(result);
        }
    };
    (0, react_1.useEffect)(() => {
        if (prevData.current === data && (0, fast_deep_equal_1.default)(prevSelectedIds.current, selectedIds)) {
            return;
        }
        prevData.current = data;
        prevSelectedIds.current = selectedIds;
        setSelected(computeSelected([], selectedIds || []));
    });
    function mergeIncomingValues(existValues, incomingValues) {
        const resultValues = existValues.slice();
        incomingValues.forEach((incomingValue) => {
            const foundIndex = resultValues.indexOf(incomingValue);
            if (foundIndex > -1) {
                resultValues.splice(foundIndex, 1);
            }
            else {
                resultValues.push(incomingValue);
            }
        });
        return resultValues;
    }
    const actions = {
        toggleByIndex: (index, callback) => {
            setSelectedIdList(computeSelected(mode === SELECTION_MOD.single
                ? [index]
                : mergeIncomingValues(selected.indexList, [index]), []), callback);
        },
        toggleById: (id, callback) => {
            setSelectedIdList(computeSelected([], mode === SELECTION_MOD.single
                ? [id]
                : mergeIncomingValues(selected.idList, [id])), callback);
        },
        selectAll: (callback) => {
            setSelectedIdList(computeSelected([], data.map(idAccessor)), callback);
        },
        deselectAll: (callback) => {
            setSelectedIdList(computeSelected([], []), callback);
        }
    };
    return [selected, actions];
}
exports.useSelection = useSelection;
//# sourceMappingURL=useSelection.js.map